import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { Box, Typography } from '@mui/material';
import CreateSOAForm from '@/components/forms/CreateSOAForm';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

const DealSOAFormPage = () => {
	const { getFeatureFlags } = useFeatureFlagContext();
	const showSOA = Boolean(getFeatureFlags('statementOfAdvice')?.active);

	return (
		<AuthenticatedPageLayout>
			<Box padding={3}>
				{showSOA ? (
					<CreateSOAForm />
				) : (
					<Typography variant='h4'>
						{'Statement of Advice generator coming soon.'}
					</Typography>
				)}
			</Box>
		</AuthenticatedPageLayout>
	);
};

export default DealSOAFormPage;
